import { PanelCloseCustomData } from '../../datapoints';
import differenceInMilliseconds from 'owa-datetime/lib/owaDate/differenceInMilliseconds';
import getStore from '../../store/store';
import now from 'owa-datetime/lib/userDate/now';

export default function getPanelCloseCustomData(): PanelCloseCustomData {
    return {
        sessionDuration: getSessionDuration(),
    };
}

function getSessionDuration() {
    const panelOpenTime = getStore().panelOpenTime;
    return panelOpenTime ? differenceInMilliseconds(now(), panelOpenTime) : null;
}
